import script from "./addstyle.vue?vue&type=script&setup=true&lang=js"
export * from "./addstyle.vue?vue&type=script&setup=true&lang=js"

import "./addstyle.vue?vue&type=style&index=0&id=f2c32372&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2c32372"]])

export default __exports__